export default __webpack_public_path__ + "static/media/Path -1@2x.b4eb9a6a.png";